<script setup lang="ts">
withDefaults(defineProps<{ name: "home" | "heart" | "message" | "user" | "plus" | "check" | "chevron"; size?: number }>(), {
  size: 22,
});
</script>

<template>
  <svg
    class="app-icon"
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <!-- MessageCircleIcon from imfenghuang/icons, MIT; simplified to a static accessible glyph. -->
    <path v-if="name === 'message'" d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z" />
    <template v-else-if="name === 'home'">
      <path d="M3 10a2 2 0 0 1 .709-1.528l7-5.999a2 2 0 0 1 2.582 0l7 5.999A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
      <path d="M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8" />
    </template>
    <path v-else-if="name === 'heart'" d="M20.8 8.8c0 5.5-8.8 10.2-8.8 10.2S3.2 14.3 3.2 8.8A4.8 4.8 0 0 1 12 6.1a4.8 4.8 0 0 1 8.8 2.7Z" />
    <template v-else-if="name === 'user'">
      <circle cx="12" cy="8" r="5" />
      <path d="M20 21a8 8 0 0 0-16 0" />
    </template>
    <template v-else-if="name === 'plus'">
      <path d="M12 5v14M5 12h14" />
    </template>
    <path v-else-if="name === 'chevron'" d="m9 5 7 7-7 7" />
    <template v-else>
      <circle cx="12" cy="12" r="10" />
      <path d="m9 12 2 2 4-4" />
    </template>
  </svg>
</template>
